<template>
  <div class="m-4">
    <h2 @click="test" class="">
      {{
        isViewMode
          ? "Visualizza Leziono"
          : isEditMode
          ? "Modifica Leziono"
          : "Nuovo Lezioni"
      }}
    </h2>

    <div v-if="loading">Loading...</div>
    <div
      v-else-if="lessonNotFound"
      class="alert alert-danger"
      role="alert"
      style="color: white"
    >
      Non hai il permesso di visualizzare le informazioni di questa lezione.
    </div>

    <div v-if="!lessonNotFound">
      <div v-if="isEditMode || isViewMode">
        <div v-if="lessonNotFound">
          <p>Lesson not found. Please check the ID.</p>
        </div>
        <div v-else>
        </div>
      </div>

      <div v-else>
        <p>Compila il form per inserire un nuovo </p>
      </div>
      <div
        class="py-4 container-fluid"
      >
        <Vueform
          ref="form$"
          v-model="lesson"
          :disabled="isViewMode"
          sync
          style="display: block"
          @submit.prevent=""
        >
          <div class="mt-3 row">
            <div class="mt-4 col-12 col-md-4 col-xl-4 mt-xl-0">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <h6 class="mb-0">Dati della Lezione</h6>
                </div>
                <div class="p-4 px-md-4 card-body">
                  <HiddenElement name="id" />
                  <div class="mb-3">
                    <SelectElement
                      :disabled="isViewMode"
                      name="student_id"
                      :delay="500"
                      label="Studento"
                      rules="required"
                      placeholder="Studento"
                      :items="searchStudents"
                      :search="true"
                    ></SelectElement>
                  </div>
                  <div class="mb-3">
                    <SelectElement
                      :disabled="isViewMode"
                      :search="true"
                      name="instructor_id"
                      :native="false"
                      label="Istruttore"
                      rules="required"
                      placehoder="Istruttore"
                      :items="instructors"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectElement
                      :disabled="isViewMode"
                      :search="true"
                      name="riding_stable_id"
                      :native="false"
                      label="Scuderia"
                      rules="required"
                      placehoder="Scuderia"
                      :items="ridingStables"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectElement
                      :disabled="
                        isViewMode ||
                        !lesson.student_id ||
                        !lesson.riding_stable_id
                      "
                      :search="true"
                      name="horse_id"
                      :native="false"
                      label="ID Cavallo"
                      rules="required"
                      placehoder="Cavallo"
                      :items="horses"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectElement
                      :disabled="isViewMode"
                      :search="true"
                      name="groom_id"
                      :native="false"
                      label="Maniscalco"
                      rules="required"
                      placehoder="Maniscalco"
                      :items="grooms"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectElement
                      :native="false"
                      :disabled="isViewMode"
                      :search="true"
                      name="lesson_type_id"
                      label="Tipo di Lezione"
                      rules="required"
                      placehoder="Tipo di Lezione"
                      :items="lessonTypes"
                    />
                  </div>
                  <div class="mb-3">
                    <SelectElement
                      :disabled="isViewMode || !lesson.riding_stable_id"
                      name="field_id"
                      :delay="500"
                      label="Campo"
                      rules="required"
                      placeholder="Campo"
                      :items="fields"
                      :search="true"
                    ></SelectElement>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-4 col-12 col-md-8 col-xl-8 mt-xl-0">
              <div class="card h-60">
                <div class="p-3 pb-0 card-header">
                  <h6 class="mb-0">Dettagli della Lezione</h6>
                </div>
                <div class="p-4 card-body">
                  <div class="mb-3">
                    <TextElement
                      :disabled="isViewMode"
                      name="title"
                      label="Titolo"
                      rules="required|string"
                      placeholder="Titolo"
                    ></TextElement>
                  </div>
                  <div class="mb-3">
                    <TextElement
                      :disabled="isViewMode"
                      name="description"
                      label="Descrizione"
                      rules="required|string"
                      placeholder="Descrizione"
                    ></TextElement>
                  </div>
                  <div class="mb-3">
                    <TextElement
                      :disabled="isViewMode"
                      name="note"
                      label="Note"
                      rules="required|string"
                      placeholder="Note"
                    ></TextElement>
                  </div>
                  <div class="mb-3">
                    <SelectElement
                      :disabled="isViewMode"
                      :search="true"
                      name="level"
                      :native="false"
                      label="Livello"
                      rules="required"
                      placehoder="Livello"
                      :items="['beginner', 'intermediate', 'advanced']"
                    />
                  </div>
                </div>
              </div>
              <div class="mt-4 card h-60">
                <div class="p-3 pb-0 card-header">
                  <h6 class="mb-0">Orari e Date della Lezione</h6>
                </div>
                <div class="p-4 card-body">
                  <div class="mb-3">
                    <DateElement
                      :disabled="isViewMode"
                      label="Data di Inizio"
                      name="start_date"
                      rules="required"
                    />
                  </div>
                  <div class="mb-3">
                    <DateElement
                      :disabled="isViewMode"
                      label="Data di Fine"
                      name="end_date"
                      rules="required"
                    />
                  </div>
                  <div class="mb-3">
                    <CheckboxgroupElement
                      name="days_of_week"
                      label="Giorni della Settimana"
                      rules="required"
                      :items="[
                        { value: 'Monday', label: 'Lunedì' },
                        { value: 'Tuesday', label: 'Martedì' },
                        { value: 'Wednesday', label: 'Mercoledì' },
                        { value: 'Thursday', label: 'Giovedì' },
                        { value: 'Friday', label: 'Venerdì' },
                        { value: 'Saturday', label: 'Sabato' },
                        { value: 'Sunday', label: 'Domenica' },
                      ]"
                    />
                  </div>
                  <div class="mb-3">
                    <DateElement
                      :disabled="isViewMode"
                      :time="true"
                      :date="false"
                      label="Orario di Inizio"
                      name="start_time"
                      rules="required"
                    ></DateElement>
                  </div>
                  <div class="mb-3">
                    <DateElement
                      :disabled="isViewMode"
                      :time="true"
                      :date="false"
                      label="Orario di Fine"
                      name="end_time"
                      rules="required"
                    ></DateElement>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            type="button"
            v-if="isViewMode"
            class="btn btn-primary my-5"
            @click="edit"
          >
            Modifica
          </button>
          <button
            type="submit"
            v-if="!isViewMode"
            :class="{ loading: loading }"
            class="btn btn-primary my-5"
            @click="save"
          >
            Salva
          </button>
        </Vueform>
      </div>
    </div>
  </div>

</template>

<script>
import Permissions from "../../services/PermissionService";
import { useToast } from "vue-toastification";
import { lessonsService } from "../../services/LessonsService";
const toast = useToast();

export default {
  name: "Lesson",
  components: { },
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
    action: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      Permissions,
      selected_request: null,
      fields: [],
      horses: [],
      instructors: [],
      students: [],
      lessonTypes: [],
      ridingStables: [],
      grooms: [],
      lesson: {
        horse_id: null,
        groom_id: "",
        riding_stable_id: "",
        lesson_type_id: "",
        student_id: "",
        field_id: "",
        note: "",
        level: "",
        description: "",
        title: "",
        end_date: "",
        start_date: "",
        days_of_week: [],
        end_time: "",
        start_time: "",
      },
      lessonNotFound: false,
    };
  },
  computed: {
    isEditMode() {
      return !!this.id;
    },
    isViewMode() {
      return this.action == "view";
    },
  },
  created() {
    this.$store.dispatch("updateBreadcrumbs", [
      { title: "Lessons", name: 'Lessons' },
    ]);
  },
  mounted() {

    const query = this.$route.query;
    if (query.instructor_id) this.lesson.instructor_id = query.instructor_id;
    if (query.horse_id) this.lesson.horse_id = query.horse_id;
    if (query.field_id) this.lesson.field_id = query.field_id;

    if (query.start_date) this.lesson.start_date = query.start_date;
    if (query.start_time) this.lesson.start_time = query.start_time;

    if (this.isEditMode || this.isViewMode) {
      this.fetchLessonData();
    }
    lessonsService.getGrooms().then((grooms) => {
      this.grooms = grooms.map((g) => ({ value: g.id, label: g.username }));
    });
    lessonsService.getRidingStables().then((stables) => {
      this.ridingStables = stables.map((t) => ({ value: t.id, label: t.name }));
    });
    lessonsService.getLessonTypes().then((types) => {
      this.lessonTypes = types.map((t) => ({ value: t.id, label: t.name }));
    });

    lessonsService.getInstructors().then((instructors) => {
      this.instructors = instructors.map((i) => ({ value: i.id, label: i.username }));
    });
  },
  watch: {
    lesson() {
      if (this.lesson.student_id && this.lesson.riding_stable_id) {
        lessonsService
          .getHorses(this.lesson.student_id, this.lesson.riding_stable_id)
          .then((horses) => {
            this.horses = horses.map((h) => ({ value: h.id, label: h.name }));
          });
      }
      if (this.lesson.riding_stable_id) {
        lessonsService
          .getFields(this.lesson.riding_stable_id)
          .then((fields) => {
            this.fields = fields.map((f) => ({ value: f.id, label: f.name }));
          });
      }
    },
  },
  methods: {
    async fetchLessonData(_id) {
      this.loading = true;
      this.lessonNotFound = false;
      try {
        const lesson = await lessonsService.get(this.id ?? _id);
        if (!lesson) {
          this.lessonNotFound = true;
        } else {
          this.lesson = lesson;
          this.lesson.days_of_week = lesson.days_of_week.split(",");
          this.lesson.start_time = new Date(lesson.start_time).toISOString().split('T')[1].slice(0, 5);
          this.lesson.end_time = new Date(lesson.end_time).toISOString().split('T')[1].slice(0, 5);
        }
      } catch (error) {
        console.error("Error fetching lesson data:", error);
        this.lessonNotFound = true;
      } finally {
        this.loading = false;
      }
    },

    async searchStudents(query) {
      this.loading = true;
      const students = await lessonsService.getStudents(query);
      console.log(students);
      this.loading = false;
      this.students = students.map((u) => ({
        value: u.id,
        label: u.username + " - " + (u.email ?? "NO EMAIL"),
      }));
      if (this.user) {
        this.students = [
          ...this.students,
          {
            value: this.user.id,
            label:
              this.user?.username + " - " + (this.user?.email ?? "NO EMAIL"),
          },
        ];
      }
      return this.students;
    },

    edit() {
      this.$router.push({ name: "Lesson", params: { id: this.id } });
    },

    async save() {
      const form = this.$refs.form$;
      await form.validate();
      if (form.data.days_of_week && Array.isArray(form.data.days_of_week)) {
        form.data.days_of_week = form.data.days_of_week.join(','); // Convert array to comma-separated string
      }
      // remove all null fields
      for (const key in form.data) {
        if (form.data[key] === "null" || form.data[key] === null) {
          delete form.data[key];
        }
      }
      if(this.isEditMode) form.data.id = this.id;
      if (!form.hasErrors) {
        this.loading = true;
        try {
          console.log(form.data);
          const _lesson = await lessonsService.save(form.data);
          console.log(_lesson);
          toast(this.$t("operation_saved"));
          if (!this.isEditMode) {
            this.$router.push({
              name: "Lesson",
              params: { id: _lesson.id },
              force: true,
            });
            this.fetchLessonData(_lesson.id);
          }
        } finally {
          this.loading = false;
        }
      }
    }
  },
};
</script>

<style>
.vf-row {
  display: block !important;
}

.vf-element-layout
  .vf-element-layout-outer-wrapper
  .vf-layout-inner-container
  .vf-checkboxgroup-wrapper {
  display: flex;
  flex-wrap: wrap;

  gap: 2rem;
}
.vf-element-layout
  .vf-element-layout-outer-wrapper
  .vf-layout-inner-container
  .vf-checkboxgroup-wrapper
  .vf-checkbox-container {
  width: 60px;
}
</style>
